import { render, staticRenderFns } from "./pre_btn_control_tan_newfile.vue?vue&type=template&id=6b359f0d&scoped=true"
import script from "./pre_btn_control_tan_newfile.vue?vue&type=script&lang=js"
export * from "./pre_btn_control_tan_newfile.vue?vue&type=script&lang=js"
import style0 from "./pre_btn_control_tan_newfile.vue?vue&type=style&index=0&id=6b359f0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b359f0d",
  null
  
)

export default component.exports